(function (angular) {
    'use strict';

    angular.module('phoneValidation')

        /**
         *
         */
        .factory('phoneValidationService',
            ['$http', '$q', 'portalConfig', '$timeout', 'growlService', '$window', '$state', '$rootScope',
                function ($http, $q, portalConfig, $timeout, growlService, $window, $state, $rootScope) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = "http://localhost:8001";

                    var fac = {
                        getSingleValidation: getSingleValidation,
                        postBulkValidation: postBulkValidation,
                        startCheckingIfValidationComplete: startCheckingIfValidationComplete,
                        getBulkValidationsDetails: getBulkValidationsDetails,
                        shouldRetry: shouldRetry
                    };

                    return fac;

                    function shouldRetry(currentWaitingTime) {
                        var nextWaitingTime = currentWaitingTime * 1.5;
                        if (nextWaitingTime <= 16000) {
                            return {
                                should: true,
                                nextWaitingTime: nextWaitingTime
                            };
                        }
                        else {
                            return {
                                should: false
                            };
                        }
                    }

                    function startCheckingIfValidationComplete(id, pickedApiSpaceId, optionalCallback) {
                        $rootScope.$broadcast('phoneValidation:started');
                        var timer = 5000;
                        var retry;
                        $timeout(run, timer);

                        function run() {
                            checkIfValidationComplete(id, pickedApiSpaceId)
                                .then(function (result) {
                                    if (result) {
                                        if ($state.current.name == "phoneValidation") {
                                            $rootScope.$broadcast('phoneValidation:complete');
                                            growlService.success('Validation complete, see results below');
                                        }
                                        else {
                                            growlService.success('<a class="growlLink" href="#/' + pickedApiSpaceId + '/phone-validation"><strong>Click into to see results of verification</strong></a>', 0);
                                        }

                                    }
                                    else {
                                        retry = fac.shouldRetry(timer);
                                        timer = retry.nextWaitingTime;
                                        if (retry.should) {
                                            $timeout(run, timer);
                                        }
                                        else {
                                            growlService.success('File validation take longer than usual - please check validation results later');

                                        }
                                    }
                                    if (optionalCallback) optionalCallback();
                                }).catch(function () {
                                    retry = fac.shouldRetry(timer);
                                    timer = retry.nextWaitingTime;
                                    if (retry.should) {
                                        $timeout(run, timer);
                                    }
                                    else {
                                        growlService.success('File validation take longer than usual - please check validation results later');

                                    }
                                    if (optionalCallback) optionalCallback();
                                });
                        }
                    }

                    function getBulkValidationsDetails(pickedApiSpaceId) {
                        return $http.get(urlBase + '/apispaces/' + pickedApiSpaceId + '/phonevalidation/bulk')
                            .then(getBulkValidationsDetailsComplete)
                            .catch(getBulkValidationsDetailsFailed);

                        function getBulkValidationsDetailsComplete(response) {
                            return response.data;
                        }

                        function getBulkValidationsDetailsFailed(error) {
                            return $q.reject(error);
                        }
                    }

                    function checkIfValidationComplete(id, pickedApiSpaceId) {
                        return $http.get(urlBase + '/apispaces/' + pickedApiSpaceId + '/phonevalidation/bulk/' + id + '?ready=true', {
                            "async": true
                        })
                            .then(checkIfValidationCompleteComplete)
                            .catch(checkIfValidationCompleteFailed);

                        function checkIfValidationCompleteComplete(response) {
                            return response.data;
                        }

                        function checkIfValidationCompleteFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function postBulkValidation(data, separator, country, isHeader, phoneField, isInternational, pickedApiSpaceId) {
                        var fd = new FormData();
                        fd.append("csv", data);
                        if (country) {
                            fd.append("country", country);
                        }
                        fd.append("separator", separator);
                        fd.append("isHeader", isHeader);
                        fd.append("phoneField", phoneField);
                        fd.append("isInternational", isInternational);
                        return $http.post(urlBase + '/apispaces/' + pickedApiSpaceId + "/phonevalidation/bulk", fd, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }

                        }, { billing: true })
                            .then(postBulkValidationComplete)
                            .catch(postBulkValidationFailed);

                        function postBulkValidationComplete(response) {
                            return response.data;
                        }

                        function postBulkValidationFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function getSingleValidation(number, countryCode, pickedApiSpaceId) {
                        var query = '?phoneNumber=' + number;
                        query = countryCode ? query + '&countryCode=' + countryCode : query;
                        return $http.get(urlBase + '/apispaces/' + pickedApiSpaceId + '/phonevalidation/single' + query, { billing: true })
                            .then(getSingleValidationComplete)
                            .catch(getSingleValidationFailed);

                        function getSingleValidationComplete(response) {
                            return response.data;
                        }

                        function getSingleValidationFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);
